import { ParallaxProvider } from "react-scroll-parallax";

import Hero from "../components/Hero.jsx";
import Intro from "../components/Intro.jsx";
import Products from "../components/Products.jsx";

const Homepage = () => {
	return (
		<ParallaxProvider>
			<main className="flex w-full flex-col items-center justify-center overflow-x-hidden">
				<Hero />
				<Intro />
				<Products />
			</main>
		</ParallaxProvider>
	);
};

export default Homepage;
